import { environment } from '../../../environments/environment';

export interface UserSession {
  accessToken: string;
  expiresIn: number;
  absoluteExpiresIn: number;
  needRefresh: boolean;
  needReauth: boolean;
  tokenType: string;

  issuedAt?: number;
}

export interface User {
  userId: string;
  email: string;
  firstName?: string;
  lastName?: string;
  avatar?: string;
  groups: string[];
}

export interface JwtPayload {
  sub: string;
  email: string;
  groups?: string;
  family_name?: string;
  given_name?: string;
  picture?: string;
}

export const UserGroup = environment.userGroups;

export type UserGroup = (typeof UserGroup)[keyof typeof UserGroup];
